import React from "react";

const ServicesPage = () => {
  return (
    <div className="bg-gray-50">

      {/* For Job Seekers */}
      <div className="text-center py-8">
        <h1 className="text-5xl font-bold text-blue-700">For Job Seekers</h1>
      </div>

      {/* Service 4: Job Placement Assistance */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full p-12 bg-white shadow-md rounded-lg mb-12">
        <div className="md:w-1/2">
          <img
            src="https://wowidea.in/wp-content/uploads/elementor/thumbs/two-men-are-looking-resume-report-scaled-qbddbcm2ue6gbir2u5ms84zq4ye42u0sy7idsrdlh4.jpg" // Replace with your actual GIF link
            alt="Job Placement Assistance"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold text-blue-600 mb-4">Job Placement Assistance</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            Connecting candidates with job opportunities matching their profiles. We also provide ongoing support during the recruitment process.
          </p>
        </div>
      </div>

      {/* Service 5: Mock Interviews */}
      <div className="flex flex-col md:flex-row-reverse items-center justify-between w-full p-12 bg-gradient-to-r from-purple-400 via-pink-300 to-red-400 text-white shadow-md rounded-lg mb-12">
        <div className="md:w-1/2">
          <img
            src="https://www.workitdaily.com/media-library/one-colleague-help-another-during-a-mock-job-interview.jpg?id=21125520&width=800&quality=85" // Replace with your actual GIF link
            alt="Mock Interviews"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold mb-4">Mock Interviews</h2>
          <p className="text-lg leading-relaxed">
            Industry-specific interview practice sessions with personalized feedback and improvement strategies to enhance your confidence and skills.
          </p>
        </div>
      </div>

      {/* For Employers */}
      <div className="text-center py-8">
        <h1 className="text-5xl font-bold text-blue-700">For Employers</h1>
      </div>

      {/* Service 1: Talent Acquisition */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full p-12 bg-white shadow-md rounded-lg mb-12">
        <div className="md:w-1/2">
          <img
            src="https://www.ismartrecruit.com/upload/blog/main_image/Talent_Acquisition_vs_Talent_Management_vs_Human_Resource.webp" // Replace with your actual GIF link
            alt="Talent Acquisition"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold text-blue-600 mb-4">Talent Acquisition</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            End-to-end recruitment services for all levels of positions, specializing in niche and senior roles.
          </p>
        </div>
      </div>

      {/* Service 2: Background Verification */}
      <div className="flex flex-col md:flex-row-reverse items-center justify-between w-full p-12 bg-gradient-to-r from-green-400 via-blue-300 to-teal-400 text-white shadow-md rounded-lg mb-12">
        <div className="md:w-1/2">
          <img
            src="https://media.licdn.com/dms/image/D4D12AQGkxVHsidKmwQ/article-cover_image-shrink_720_1280/0/1675023239546?e=2147483647&v=beta&t=qxWRFpp2-NNxHo9rbRcuI_vB-DWb3Gw3cwMpIz_1oaE" // Replace with your actual GIF link
            alt="Background Verification"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold mb-4">Background Verification</h2>
          <p className="text-lg leading-relaxed">
            Comprehensive employee background checks to ensure credibility and trustworthiness.
          </p>
        </div>
      </div>

      {/* Service 3: Workforce Planning */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full p-12 bg-white shadow-md rounded-lg mb-12">
        <div className="md:w-1/2">
          <img
            src="https://devskiller.com/wp-content/uploads/2023/02/Workforce-planning.png" // Replace with your actual GIF link
            alt="Workforce Planning"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold text-blue-600 mb-4">Workforce Planning</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            Customized workforce strategies to meet organizational needs and achieve long-term goals.
          </p>
        </div>
      </div>

      {/* Service 4: Campus Recruitment Services */}
      <div className="flex flex-col md:flex-row-reverse items-center justify-between w-full p-12 bg-gradient-to-r from-yellow-400 via-orange-300 to-red-400 text-white shadow-md rounded-lg mb-12">
        <div className="md:w-1/2">
          <img
            src="https://www.wsneconsulting.com/img/content/services/serv-18.jpg" // Replace with your actual GIF link
            alt="Campus Recruitment"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold mb-4">Campus Recruitment Services</h2>
          <p className="text-lg leading-relaxed">
            Partnering with educational institutions for fresh talent acquisition and organizing campus placement drives.
          </p>
        </div>
      </div>

      {/* Service 5: Contract Staffing */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full p-12 bg-white shadow-md rounded-lg">
        <div className="md:w-1/2">
          <img
            src="https://5.imimg.com/data5/SELLER/Default/2024/2/383961659/UD/XJ/ZO/46775206/contract-staffing-services.png" // Replace with your actual GIF link
            alt="Contract Staffing"
            className="w-3/4 h-auto object-cover rounded-lg shadow-lg mx-auto"
          />
        </div>
        <div className="md:w-1/2 text-center md:text-left p-6">
          <h2 className="text-4xl font-semibold text-blue-600 mb-4">Contract Staffing</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            Temporary staffing solutions to meet short-term project needs with flexibility and efficiency.
          </p>
        </div>
      </div>

    </div>
  );
};

export default ServicesPage;
